import React from "react";
import Table from "../ReactTable/Table";
import { useTranslation } from "react-i18next";
import { replaceTimeZone } from "../../utils/datetime";
import moment from "moment-timezone";
import { Button, Box, Typography } from "@mui/material";
import Modal from "../Modal";
import makeStyles from "@mui/styles/makeStyles";
import { ReportProblemOutlined } from "@mui/icons-material";
import useModal from "../../hooks/useModal";

const columns = t => [
  {
    Header: t("scheduleSession.nameLabel"),
    accessor: "name"
  },
  {
    Header: t("scheduleSession.startDateLabel"),
    id: "startDate",
    accessor: "startDate",
    Cell: ({ row: { original } }) =>
      moment(replaceTimeZone(original.startDate))
        .format("MM/DD/YYYY")
        .toString()
  },
  {
    Header: t("scheduleSession.startTimeLabel"),
    id: "startTime",
    Cell: ({ row: { original } }) =>
      moment(replaceTimeZone(original.startDate))
        .format("hh:mm A z")
        .toString(),
    accessor: ({ startDate }) =>
      moment(replaceTimeZone(startDate)).format("hh:mm")
  },
  {
    Header: t("scheduleSession.endDateLabel"),
    id: "endDate",
    accessor: "endDate",
    Cell: ({ row: { original } }) =>
      moment(replaceTimeZone(original.endDate))
        .format("MM/DD/YYYY")
        .toString()
  },
  {
    Header: t("scheduleSession.endTimeLabel"),
    id: "endTime",
    Cell: ({ row: { original } }) =>
      moment(replaceTimeZone(original.endTime))
        .format("hh:mm A z")
        .toString(),
    accessor: ({ endDate }) =>
      moment(replaceTimeZone(endDate))
        .format("hh:mm")
        .toString()
  }
];

const useStyles = makeStyles(() => ({
  icon: {
    width: "100%",
    height: "100%"
  },
  sessions: {
    cursor: "pointer"
  }
}));

const InstructorSessionsModal = props => {
  const { t } = useTranslation();
  const { onResult, sessions } = props;

  const classes = useStyles();
  return (
    <Modal
      scrollable
      maxWidth="md"
      fullWidth
      dialogContent={
        <Box display="flex" flexDirection="column">
          <Box display="flex" mt={1} mb={1}>
            <Box mr={1.5} minWidth={60} maxWidth={120} height={60}>
              <ReportProblemOutlined color="primary" className={classes.icon} />
            </Box>
            <Typography variant="body1">
              {t("editInstructorModal.changeTypeError")}
            </Typography>
          </Box>
          <Table
            maxHeight={500}
            columns={columns(t)}
            data={sessions || []}
            manualFilters={false}
            manualSortBy={false}
            cellSize="medium"
          />
        </Box>
      }
      dialogActions={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onResult(null);
          }}
        >
          {t("okBtn")}
        </Button>
      }
      open={open}
    />
  );
};

const InstructorSessions = ({ sessions }) => {
  const openModal = useModal(InstructorSessionsModal);
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Typography variant="body2" color="textSecondary">
      {t("editInstructorModal.showSessionsWarningMessage")}
      <u
        onClick={() =>
          openModal({
            sessions: sessions
          })
        }
        className={classes.sessions}
      >
        {t("editInstructorModal.showSessionsWarningMessageLink")}
      </u>
    </Typography>
  );
};

export default InstructorSessions;
